import { StoredRegistration } from '../types/onboardingRegistration'

export const ONBOARDING_REGISTRATION_KEY = 'onboardingRegistration'

export function saveRegistration(data: StoredRegistration): void {
  sessionStorage.setItem(ONBOARDING_REGISTRATION_KEY, JSON.stringify(data))
}

export function loadRegistration(): StoredRegistration | null {
  const raw = sessionStorage.getItem(ONBOARDING_REGISTRATION_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw) as StoredRegistration
  } catch {
    return null
  }
}

export function markRegistrationVerified(): StoredRegistration | null {
  const existing = loadRegistration()
  if (!existing) return null
  const updated: StoredRegistration = {
    ...existing,
    emailVerified: true,
    verifiedAt: new Date().toISOString(),
  }
  saveRegistration(updated)
  return updated
}

export function clearRegistration(): void {
  sessionStorage.removeItem(ONBOARDING_REGISTRATION_KEY)
}
